/**
 * Small credential line — sits below the "selah" rule ornament in each page footer.
 * Site-wide credibility signal.
 */
export default function MinisterCredential() {
  return (
    <p
      className="mt-6 text-center font-serif-display italic text-[13px] tracking-wide"
      style={{ color: "var(--stone-deep)" }}
      data-testid="footer-minister-credential"
    >
      Founded and stewarded by a licensed minister.
    </p>
  );
}
